import { useState } from 'react';

const useForm = (initialValues = {}) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setValues(prevValues => ({
            ...prevValues,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Clear error when field is changed
        if (errors[name]) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [name]: null
            }));
        }
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched(prevTouched => ({
            ...prevTouched,
            [name]: true
        }));
    };

    const resetForm = () => {
        setValues(initialValues);
        setErrors({});
        setTouched({});
    };

    const setFieldValue = (name, value) => {
        setValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    const setFieldTouched = (name, isTouched = true) => {
        setTouched(prevTouched => ({
            ...prevTouched,
            [name]: isTouched
        }));
    };

    const setFieldError = (name, error) => {
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: error
        }));
    };

    const validateForm = (validationSchema) => {
        const newErrors = {};
        let isValid = true;

        // Simple validation example - can be expanded based on requirements
        Object.keys(validationSchema).forEach(key => {
            const value = values[key];
            const fieldSchema = validationSchema[key];

            if (fieldSchema.required && (!value || value === '')) {
                newErrors[key] = fieldSchema.errorMessage || 'This field is required';
                isValid = false;
            } else if (fieldSchema.min && value && value.length < fieldSchema.min) {
                newErrors[key] = fieldSchema.errorMessage || `Minimum length is ${fieldSchema.min}`;
                isValid = false;
            } else if (fieldSchema.max && value && value.length > fieldSchema.max) {
                newErrors[key] = fieldSchema.errorMessage || `Maximum length is ${fieldSchema.max}`;
                isValid = false;
            } else if (fieldSchema.pattern && value && !fieldSchema.pattern.test(value)) {
                newErrors[key] = fieldSchema.errorMessage || 'Invalid format';
                isValid = false;
            }
        });

        setErrors(newErrors);
        return isValid;
    };

    return {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        resetForm,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        validateForm,
        setValues
    };
};

export default useForm;